export const clearAllData = async () => {
  // Clear localStorage
  localStorage.clear();

  // Clear sessionStorage
  sessionStorage.clear();

  // Clear all cookies
  document.cookie.split(';').forEach((c) => {
    document.cookie = c.trim().split('=')[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
  });

  // Clear IndexedDB
  const databases = await indexedDB.databases();
  for (const db of databases) {
    await indexedDB.deleteDatabase(db.name as string);
  }

  // Clear Cache Storage if supported
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    for (const name of cacheNames) {
      await caches.delete(name);
    }
  }

  // Deregister all Service Workers if supported
  if ('serviceWorker' in navigator && navigator.serviceWorker.getRegistrations) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
    }
  }

  window.location.href = '/login';
};
